<template>
  <div class="map-remote-controls">
    <div class="map-remote-controls__grid">
      <span class="map-remote-controls__cell map-remote-controls__cell--empty" />
      <button type="button" class="map-remote-controls__btn" @click="$emit('pan', 'up')">
        <i class="el-icon-arrow-up" />
      </button>
      <span class="map-remote-controls__cell map-remote-controls__cell--empty" />
      <button type="button" class="map-remote-controls__btn" @click="$emit('pan', 'left')">
        <i class="el-icon-arrow-left" />
      </button>
      <button type="button" class="map-remote-controls__btn" @click="$emit('pan', 'right')">
        <i class="el-icon-arrow-right" />
      </button>
      <button type="button" class="map-remote-controls__btn" title="全屏" @click="$emit('fullscreen')">
        <i class="el-icon-full-screen" />
      </button>
      <span class="map-remote-controls__cell map-remote-controls__cell--empty" />
      <button type="button" class="map-remote-controls__btn" @click="$emit('pan', 'down')">
        <i class="el-icon-arrow-down" />
      </button>
      <span class="map-remote-controls__cell map-remote-controls__cell--empty" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapRemoteControls',
}
</script>

<style lang="scss" scoped>
.map-remote-controls {
  pointer-events: auto;

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 29px);
    grid-template-rows: repeat(3, 29px);
    gap: 2px;
  }

  &__cell--empty {
    display: block;
  }

  &__btn {
    width: 29px;
    height: 29px;
    padding: 0;
    border: 1px solid #ccc;
    border-radius: 50%;
    background: #fff;
    color: #666;
    font-size: 14px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);

    &:hover {
      background: #f5f5f5;
      color: #333;
    }
  }
}
</style>
